import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-624c2be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "completion2-electric-options" }
const _hoisted_2 = { class: "wall-outlet-row" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "width", "height"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { style: {"font-weight":"bold","margin-bottom":"0"} }
const _hoisted_8 = {
  key: 0,
  class: "no-mb",
  style: {"font-size":"12px","font-weight":"400"}
}
const _hoisted_9 = { class: "no-mb" }
const _hoisted_10 = {
  class: "no-mb",
  style: {"font-size":"12px","font-weight":"400"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u deze optie wilt verwijderen?", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u deze optie wilt verwijderen?", -1))
const _hoisted_13 = { class: "completion2-walloutlet-image" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "completion2-walloutlet-details" }
const _hoisted_16 = { class: "completion2-walloutlet-header" }
const _hoisted_17 = { class: "subtitle" }
const _hoisted_18 = { class: "completion2-walloutlet-price" }
const _hoisted_19 = { class: "no-mb" }
const _hoisted_20 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_21 = { class: "completion2-walloutlet-content" }
const _hoisted_22 = ["innerHTML"]

import { completionTwoStore } from '@/stores/completionTwo'
import { computed, ref } from 'vue'
import { LoadingOutlined, PlusOutlined, WarningTwoTone } from '@ant-design/icons-vue'
import { Subelement } from '@/types/completion2/subelement'
import { Option } from '@/types/completion2/option'
import { EmptyWallOutlets } from '@/globalVariables'
import { generalStore } from '@/stores/general'
import ListElectricOption from '@/components/ListElectricOption.vue'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion2ElectricOptions',
  setup(__props) {

const showOptionsModal = ref(false)
const currentSubelementIndex = ref<number|null>(null)
const loadingTable = computed(() => {
  return (completionTwoStore().loading.subelements || completionTwoStore().loading.options.length > 0 || completionTwoStore().loading.selectedOption.length > 0)
})

const currentAvailableSubelementIndex = computed(() => {
  let casi = 0
  completionTwoStore().subelements.forEach((subelement:Subelement, index:number) => {
    const previousIndex = index > 0 ? index - 1 : 0
    if (completionTwoStore().subelements.length && completionTwoStore().subelements[previousIndex] && completionTwoStore().subelements[previousIndex].selected_option && completionTwoStore().subelements[previousIndex].selected_option.id !== null) {
      casi = index
    }
  })

  return casi
})

function showOptionModal (subelement:Subelement, subelementIndex:number) : void {
  if (subelementIndex === currentAvailableSubelementIndex.value && !subelement.fixed && !completionTwoStore().phaseIsClosed && !subelement.disabled) {
    currentSubelementIndex.value = subelementIndex
    showOptionsModal.value = true
  }
}

function selectWallOutlet (subelement:Subelement, subelementIndex:number, option:Option) : void {
  completionTwoStore().selectOption(subelement, subelementIndex, option)
  hideOptionModal()
}

function hideOptionModal () : void {
  showOptionsModal.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(completionTwoStore)().subelements.length)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(generalStore)().desktop ? 'wall-outlet-grid' : 'wall-outlet-grid-mobile')
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().subelements, (subelement, subelementIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass((_unref(generalStore)().desktop ? 'wall-outlet' : 'wall-outlet-mobile') + ' ' + (subelementIndex === _unref(currentAvailableSubelementIndex) && !subelement.fixed && !_unref(completionTwoStore)().phaseIsClosed && !subelement.disabled ? (_unref(completionTwoStore)().currentElement.mirrored ? 'available mirrored' : 'available') : (_unref(completionTwoStore)().currentElement.mirrored ? 'mirrored' : ''))),
                        key: subelementIndex + '-' + subelement.id,
                        onClick: ($event: any) => (showOptionModal(subelement, subelementIndex))
                      }, [
                        (subelement.selected_option && subelement.selected_option.id)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: subelement.selected_option.mainImage ? subelement.selected_option.mainImage.url : '/img/No_Image.png',
                              width: _unref(generalStore)().desktop ? 124 : 64,
                              height: _unref(generalStore)().desktop ? 124 : 64
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createElementBlock("p", _hoisted_5, [
                              (_unref(completionTwoStore)().loading.options.includes(subelement.id) || _unref(completionTwoStore)().loading.selectedOption.includes(subelement.id) || _unref(completionTwoStore)().saving.subelementId === subelement.id)
                                ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                                : (subelementIndex === _unref(currentAvailableSubelementIndex) && !_unref(completionTwoStore)().phaseIsClosed && !subelement.disabled)
                                  ? (_openBlock(), _createBlock(_unref(PlusOutlined), { key: 1 }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_6))
                            ])),
                        (subelement.fixed)
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 2,
                              color: "#f38929",
                              style: _normalizeStyle(_unref(generalStore)().desktop ? { position: 'absolute', margin: '94px 0 0 8px' } : { position: 'absolute', margin: '36px 0 0 2px' })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(generalStore)().desktop ? 'Standaard' : 'Std'), 1)
                              ]),
                              _: 1
                            }, 8, ["style"]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_3))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(generalStore)().desktop ? 'position-row' : 'position-row-mobile')
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().subelements, (subelement, subelementIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["wall-outlet-position", _unref(completionTwoStore)().currentElement.mirrored ? 'mirrored' : '']),
                        key: subelementIndex + '-' + subelement.id
                      }, "Positie " + _toDisplayString(_unref(completionTwoStore)().currentElement.position) + "." + _toDisplayString(subelement.position), 3))
                    }), 128))
                  ], 2)
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(generalStore)().desktop)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: [{ title: 'Positie', key: 'position'}, { title: 'Optie', key: 'option'}, { title: 'Prijs', key: 'price'}, { title: '', key: 'actions'}],
                  loading: _unref(loadingTable),
                  "data-source": _unref(completionTwoStore)().subelements,
                  pagination: false
                }, {
                  bodyCell: _withCtx(({ column, record, index }) => [
                    (column.key === 'position')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(completionTwoStore)().currentElement.position) + "." + _toDisplayString(record.position), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'option')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (record.selected_option)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("p", _hoisted_7, _toDisplayString(record.disabled && record.selected_option.name === 'Maak een keuze..' ? '-' : record.selected_option.name), 1),
                                (record.selected_option.externalRef)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Optie nr. " + _toDisplayString(record.selected_option.externalRef), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'price')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (record.selected_option && record.selected_option.externalRef)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("p", _hoisted_9, "€ " + _toDisplayString(record.selected_option.price), 1),
                                _createElementVNode("p", _hoisted_10, "incl. " + _toDisplayString(record.selected_option.vat_rate) + "% BTW", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("-")
                              ], 64))
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.key === 'actions')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          (!record.fixed && record.selected_option && !_unref(completionTwoStore)().phaseIsClosed && !record.disabled)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (index === _unref(currentAvailableSubelementIndex) && !record.selected_option.id)
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 0,
                                      disabled: _unref(authStore)().restricted(),
                                      size: "small",
                                      onClick: ($event: any) => (showOptionModal(record, index))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Kies")
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true),
                                ((index + 1 === _unref(completionTwoStore)().subelements.length && record.selected_option.id) || (index + 1 !== _unref(completionTwoStore)().subelements.length && record.selected_option.id && _unref(completionTwoStore)().subelements[index + 1].selected_option && !_unref(completionTwoStore)().subelements[index + 1].selected_option.id))
                                  ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                      key: 1,
                                      disabled: _unref(authStore)().restricted(),
                                      placement: "topRight",
                                      "ok-text": "Ja",
                                      "cancel-text": "Nee",
                                      onConfirm: ($event: any) => (_unref(completionTwoStore)().removeWallOutlet(record, index))
                                    }, {
                                      title: _withCtx(() => [
                                        _hoisted_11
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          size: "small",
                                          style: {"margin-top":"8px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Verwijder")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onConfirm"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading", "data-source"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(completionTwoStore)().subelements, (record, index) => {
          return (_openBlock(), _createBlock(ListElectricOption, {
            subelement: record,
            "last-item": index + 1 === _unref(completionTwoStore)().subelements.length,
            key: record.id
          }, _createSlots({ _: 2 }, [
            (!record.fixed && record.selected_option && !_unref(completionTwoStore)().phaseIsClosed && !record.disabled)
              ? {
                  name: "buttons",
                  fn: _withCtx(() => [
                    (index === _unref(currentAvailableSubelementIndex) && !record.selected_option.id)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          disabled: _unref(authStore)().restricted(),
                          size: "small",
                          style: {"margin-top":"8px"},
                          onClick: ($event: any) => (showOptionModal(record, index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Kies")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : _createCommentVNode("", true),
                    ((index + 1 === _unref(completionTwoStore)().subelements.length && record.selected_option.id) || (index + 1 !== _unref(completionTwoStore)().subelements.length && record.selected_option.id && _unref(completionTwoStore)().subelements[index + 1].selected_option && !_unref(completionTwoStore)().subelements[index + 1].selected_option.id))
                      ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                          key: 1,
                          disabled: _unref(authStore)().restricted(),
                          placement: "topRight",
                          "ok-text": "Ja",
                          "cancel-text": "Nee",
                          onConfirm: ($event: any) => (_unref(completionTwoStore)().removeWallOutlet(record, index))
                        }, {
                          title: _withCtx(() => [
                            _hoisted_12
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              size: "small",
                              style: {"margin-top":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Verwijder")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onConfirm"]))
                      : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["subelement", "last-item"]))
        }), 128)),
    (_unref(completionTwoStore)().subelements.length && _unref(completionTwoStore)().subelements[currentSubelementIndex.value] && _unref(completionTwoStore)().subelements[currentSubelementIndex.value].options)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 3,
          title: "Kies een schakelaar.",
          width: "800px",
          footer: false,
          visible: showOptionsModal.value,
          onCancel: hideOptionModal
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().subelements[currentSubelementIndex.value].options, (option, optionIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.id
              }, [
                (option.id !== null && !_unref(EmptyWallOutlets).includes(option.externalRef))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_unref(generalStore)().desktop ? 'completion2-walloutlet-list-item' : 'completion2-walloutlet-list-item-mobile')
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("img", {
                              src: option.mainImage ? option.mainImage.url : '/img/No_Image.png',
                              width: "128"
                            }, null, 8, _hoisted_14)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", null, [
                                _createTextVNode(_toDisplayString(option.name) + " ", 1),
                                (option.excluded_from_warranty)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                      title: _withCtx(() => [
                                        _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_unref(WarningTwoTone), {
                                          "two-tone-color": "#f38929",
                                          style: {"margin-left":"4px"}
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_17, "Optie nr. " + _toDisplayString(option.externalRef), 1)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("p", _hoisted_19, "€ " + _toDisplayString(option.price), 1),
                              _createElementVNode("p", _hoisted_20, "incl. " + _toDisplayString(option.vat_rate) + "% BTW", 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("p", {
                                innerHTML: option.textSales
                              }, null, 8, _hoisted_22),
                              _createVNode(_component_a_button, {
                                disabled: _unref(authStore)().restricted(),
                                onClick: ($event: any) => (selectWallOutlet(_unref(completionTwoStore)().subelements[currentSubelementIndex.value], currentSubelementIndex.value, option))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Kies")
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ])
                          ])
                        ], 2),
                        (_unref(completionTwoStore)().subelements[currentSubelementIndex.value].options.length !== optionIndex + 1)
                          ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})